// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.production-lines-split {
  display: flex;
  gap: 16px;
  min-height: 500px;
}
.production-lines-split .production-lines-list-panel {
  flex: 1 1;
  min-width: 0;
}
.production-lines-split .production-lines-form-panel {
  flex: 1 1;
  min-width: 320px;
  max-width: 480px;
}

.production-line-form {
  padding: 16px;
}
.production-line-form .form-row {
  display: flex;
  gap: 16px;
}
@media (max-width: 767.98px) {
  .production-line-form .form-row {
    flex-direction: column;
  }
}
.production-line-form .form-row .form-group {
  flex: 1 1;
}
.production-line-form .form-group {
  margin-bottom: 1rem;
}
.production-line-form .form-group .small {
  font-size: 0.85rem;
}
.production-line-form .form-actions {
  display: flex;
  gap: 8px;
  margin-top: 1.5rem;
}
.production-line-form .machine-item-block {
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 10px;
  margin-bottom: 10px;
}
.production-line-form .machine-item-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.production-line-form .machine-item-header .order-btns {
  display: flex;
  align-items: center;
  gap: 2px;
}
.production-line-form .machine-item-header .order-btns .order-num {
  min-width: 20px;
}
.production-line-form .machine-item-header .dropdown-trigger {
  flex: 1 1;
}
.production-line-form .machine-inventory {
  margin-left: 28px;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #666;
}
.loading-container .spin {
  animation: spin 1s linear infinite;
}
.loading-container p {
  margin-top: 16px;
  font-size: 16px;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #999;
}
.empty-state p {
  margin-top: 16px;
  font-size: 16px;
}

.dropdown-trigger {
  padding: 10px 12px;
  border: 1px solid #d0d5dd;
  border-radius: 4px;
  cursor: pointer;
  background: #fff;
  min-height: 42px;
}

.line-items-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.line-items-list.grid-3 {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}
.line-items-list li {
  padding: 8px 12px;
  background: #f8f9fa;
  border-radius: 4px;
  margin-bottom: 6px;
}

.production-line-form .form-control {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

/* --- ANALYTICS SECTION --- */
.pl-analytics {
  margin-bottom: 1.5rem;
  padding: 1rem;
  border: 1px solid var(--m-border, #e0e0e0);
  border-radius: 6px;
  background: var(--m-card-background-color, #fff);
}

.pl-analytics-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 1rem;
  font-size: 15px;
}

.pl-analytics-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}
@media (max-width: 900px) {
  .pl-analytics-grid {
    grid-template-columns: 1fr;
  }
}

.pl-analytics-card {
  padding: 0.75rem;
  border: 1px solid #eee;
  border-radius: 6px;
  background: #fafafa;
}
.pl-analytics-card h6 {
  margin-bottom: 0.75rem;
  font-size: 13px;
  color: var(--m-text, #333);
}
.pl-analytics-card.pl-analytics-card--full {
  grid-column: 1/-1;
  padding: 1rem 1.25rem;
  background: #f9fafb;
  border-color: #e5e7eb;
}
.pl-analytics-card .pl-analytics-card__header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}
.pl-analytics-card .pl-analytics-card__header h6 {
  margin: 0;
  font-size: 0.9rem;
}
.pl-analytics-card .pl-analytics-card__header .pl-model-select-wrap {
  min-width: 220px;
  max-width: 320px;
  margin-bottom: 0;
}
.pl-analytics-card .pl-analytics-card__body {
  border-top: 1px solid #e5e7eb;
  padding-top: 0.75rem;
}

.pl-usage-line {
  margin-bottom: 0.75rem;
  font-size: 12px;
}
.pl-usage-line strong {
  display: block;
  margin-bottom: 4px;
}

/* --- INVENTORY SECTION (line items) --- */
.pl-inventory-section {
  padding: 1rem 1.25rem;
  border: 1px solid var(--m-border, #e0e0e0);
  border-radius: 6px;
  background: var(--m-card-background-color, #fff);
}

.pl-section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 1rem;
  font-size: 15px;
}

.pl-inventory-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.pl-inventory-card {
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #f9fafb;
  padding: 10px 14px;
  min-width: 200px;
}
.pl-inventory-card .pl-inventory-card__body {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 12px;
}
.pl-inventory-card .pl-inventory-name {
  font-weight: 600;
  font-size: 14px;
}
.pl-inventory-card .pl-inventory-code {
  font-size: 12px;
  color: #6b7280;
}
.pl-inventory-card .pl-inventory-qty {
  font-size: 12px;
  color: #374151;
}

.pl-usage-machine {
  padding-left: 1rem;
  margin-bottom: 4px;
}
.pl-usage-machine .pl-usage-machine-name {
  display: inline-block;
  min-width: 120px;
}
.pl-usage-machine .pl-usage-item {
  display: inline-block;
  margin-right: 8px;
  padding: 2px 6px;
  background: #e8f4fd;
  border-radius: 4px;
}

/* when showing only totals per line */
.pl-usage-total-list {
  padding-left: 0.5rem;
}

.pl-model-select-wrap {
  margin-bottom: 0.75rem;
}

.pl-model-detail {
  font-size: 12px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.pl-model-detail .pl-model-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
  margin-bottom: 0.75rem;
}
.pl-model-detail .pl-model-stats .pl-model-produced {
  color: #0ea5e9;
}
.pl-model-detail .pl-model-stats .pl-model-max {
  color: #22c55e;
}
.pl-model-detail .pl-model-stats .pl-model-shortage {
  color: #ef4444;
}
.pl-model-detail .pl-model-stats .pl-model-bottleneck {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #f59e0b;
}
.pl-model-detail .pl-model-usage {
  margin-top: 0.5rem;
  display: block;
}
.pl-model-detail .pl-model-usage .pl-model-usage-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 6px 0;
  margin-bottom: 4px;
  border: 0;
  background: transparent;
  font-size: 12px;
  font-weight: 600;
  color: #334155;
  cursor: pointer;
  text-align: left;
}
.pl-model-detail .pl-model-usage .pl-model-usage-toggle:hover {
  color: #0f766e;
}
.pl-model-detail .pl-model-usage .pl-model-usage-toggle-icon {
  font-weight: 700;
  font-size: 14px;
  color: #0f766e;
  padding-left: 8px;
}
.pl-model-detail .pl-model-usage ul {
  margin: 0;
  padding-left: 1.25rem;
}
.pl-model-detail .pl-model-usage li {
  margin-bottom: 4px;
}
.pl-model-detail .pl-model-usage .pl-model-usage-stock {
  color: #94a3b8;
  font-size: 11px;
}

.text-muted {
  color: #94a3b8;
}

/* --- STEP-BASED LAYOUT --- */
.pl-lane--steps {
  margin-bottom: 1.5rem;
  border: 1px solid var(--m-border, #e2e8f0);
  border-radius: 10px;
  overflow: hidden;
  background: var(--m-card-background-color, #fff);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.pl-lane-header {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  padding: 14px 20px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-bottom: 1px solid var(--m-border, #e2e8f0);
}
.pl-lane-header .pl-name {
  font-weight: 600;
  font-size: 1.05rem;
}
.pl-lane-header .pl-code {
  font-size: 0.85rem;
  color: var(--m-text-muted, #64748b);
  padding: 2px 8px;
  background: #e2e8f0;
  border-radius: 4px;
}
.pl-lane-header .pl-badge {
  font-size: 11px;
  padding: 3px 8px;
  border-radius: 4px;
  font-weight: 500;
}
.pl-lane-header .pl-type-production {
  background: #dbeafe;
  color: #1d4ed8;
}
.pl-lane-header .pl-type-selling {
  background: #dcfce7;
  color: #15803d;
}
.pl-lane-header .pl-entry-manual {
  background: #fef3c7;
  color: #b45309;
}
.pl-lane-header .pl-entry-from_machine {
  background: #e0e7ff;
  color: #4338ca;
}
.pl-lane-header .pl-total-badge {
  margin-left: auto;
  font-size: 0.9rem;
  font-weight: 600;
  color: #0ea5e9;
  background: #e0f2fe;
  padding: 4px 12px;
  border-radius: 6px;
}

.pl-steps {
  padding: 20px;
}

.pl-steps-pipeline {
  display: flex;
  align-items: stretch;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
}

.pl-step-card {
  display: flex;
  flex-direction: column;
  flex: 0 0 220px;
  width: 220px;
  min-height: 140px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  transition: box-shadow 0.2s, border-color 0.2s;
}
.pl-step-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 4px 12px rgba(14, 165, 233, 0.08);
}

.pl-step-card-head {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  border-bottom: 1px solid #e2e8f0;
}

.pl-step-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 6px;
  background: linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%);
  color: #fff;
  font-weight: 700;
  font-size: 12px;
  flex-shrink: 0;
}

.pl-step-machine {
  font-size: 13px;
  font-weight: 600;
  color: var(--m-text, #334155);
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pl-step-card-body {
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.pl-step-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--m-text-muted, #64748b);
}

.pl-step-input-wrap {
  display: flex;
  align-items: center;
  gap: 6px;
}

.pl-produced-input {
  width: 72px;
  padding: 8px 10px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  font-size: 15px;
  font-weight: 600;
  color: #0ea5e9;
  text-align: right;
  background: #fff;
}
.pl-produced-input:focus {
  outline: none;
  border-color: #0ea5e9;
  box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.2);
}

.pl-step-unit {
  font-size: 12px;
  color: #64748b;
  font-weight: 500;
}

.pl-step-continuity {
  padding-top: 8px;
  border-top: 1px dashed #e2e8f0;
}

.pl-step-row {
  margin-bottom: 6px;
}
.pl-step-row:last-child {
  margin-bottom: 0;
}

.pl-step-sublabel {
  display: block;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  color: #94a3b8;
  margin-bottom: 4px;
}

.pl-step-continuity-value {
  display: block;
  font-size: 12px;
  color: #334155;
  font-weight: 600;
}

.pl-step-continuity-warn {
  display: block;
  font-size: 11px;
  color: #b45309;
  background: #fffbeb;
  border: 1px solid #fde68a;
  padding: 4px 6px;
  border-radius: 6px;
}

.machine-item-continuity .form-row--sm .form-group {
  flex: 1 1;
  margin-bottom: 0;
}

.pl-step-connector {
  display: flex;
  align-items: center;
  padding: 0 6px;
  color: #94a3b8;
  font-size: 18px;
  align-self: center;
  flex-shrink: 0;
}

.pl-step-actions {
  padding-top: 16px;
  border-top: 1px solid #e2e8f0;
}

@media (max-width: 600px) {
  .pl-steps-pipeline {
    flex-direction: column;
    align-items: stretch;
  }
  .pl-step-card {
    min-width: 100%;
    max-width: none;
  }
  .pl-step-connector {
    transform: rotate(-90deg);
    padding: 4px 0;
  }
}
/* --- SNAKE LAYOUT STYLES (legacy, kept if needed) --- */
.snake-container {
  display: flex;
  flex-direction: column;
  gap: 60px;
  padding: 20px 10px 40px 10px;
  overflow-x: auto;
}

.snake-row {
  display: flex;
  align-items: center;
  min-width: 500px;
}

.snake-row.ltr {
  flex-direction: row;
}

.snake-row.rtl {
  flex-direction: row-reverse;
}

.snake-node-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 60px;
  z-index: 2;
}

.pl-machine-circle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid #000080;
  background: var(--m-card-background-color, #fff);
  transition: all 0.2s;
}

.pl-circle-large {
  width: 48px;
  height: 48px;
}

.pl-machine-label {
  position: absolute;
  top: 100%;
  margin-top: 8px;
  font-size: 11px;
  color: var(--m-text-muted, #64748b);
  text-align: center;
  width: 100px;
  line-height: 1.2;
  font-weight: 500;
}

/* Base style for horizontal lines */
.snake-line-h {
  flex: 1 1;
  height: 0;
  border-top: 2px solid #000080; /* Solid line */
  min-width: 30px;
  position: relative; /* Needed for arrow positioning */
}

/* Hide lines (and their arrows) when appropriate */
.snake-line-h.hidden-line {
  border-color: transparent;
}

.snake-line-h.hidden-line::after {
  display: none;
}

/* LTR Right-pointing arrow */
.snake-row.ltr .snake-line-h::after {
  content: "";
  position: absolute;
  top: -4px; /* Centered vertically over the 2px line */
  left: 50%;
  transform: translateX(-50%);
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 8px solid #000080;
}

/* RTL Left-pointing arrow */
.snake-row.rtl .snake-line-h::after {
  content: "";
  position: absolute;
  top: -4px; /* Centered vertically over the 2px line */
  left: 50%;
  transform: translateX(-50%);
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-right: 8px solid #000080;
}

/* Base style for vertical drop lines */
.snake-line-v {
  position: absolute;
  top: 50%;
  left: 50%;
  height: 108px;
  border-left: 2px solid #000080; /* Solid line */
  z-index: -1;
  transform: translateX(-50%);
}

/* Vertical Down-pointing arrow */
.snake-line-v::after {
  content: "";
  position: absolute;
  top: 50%;
  left: -4px; /* Centered horizontally over the 2px line */
  transform: translateY(-50%);
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 8px solid #000080;
}

.pl-step-card--final {
  border-color: #22c55e;
  box-shadow: 0 0 0 2px rgba(34, 197, 94, 0.15);
}
.pl-step-card--final:hover {
  border-color: #16a34a;
  box-shadow: 0 4px 12px rgba(34, 197, 94, 0.18);
}

.pl-step-card-head--final {
  background: linear-gradient(180deg, #f0fdf4 0%, #dcfce7 100%);
  border-bottom-color: #bbf7d0;
}

.pl-step-num--final {
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
  font-size: 14px;
}

.pl-final-name {
  font-size: 14px;
  font-weight: 700;
  color: #15803d;
  line-height: 1.3;
}

.pl-final-code {
  font-size: 11px;
  font-weight: 600;
  color: #64748b;
  letter-spacing: 0.04em;
}

.pl-final-stock {
  display: inline-block;
  margin-top: 4px;
  padding: 3px 8px;
  border-radius: 20px;
  background: #dcfce7;
  color: #15803d;
  font-size: 12px;
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/views/pages/ProductionLines/ProductionLines.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,SAAA;EACA,iBAAA;AACF;AAAE;EACE,SAAA;EACA,YAAA;AAEJ;AAAE;EACE,SAAA;EACA,gBAAA;EACA,gBAAA;AAEJ;;AAEA;EACE,aAAA;AACF;AAAE;EACE,aAAA;EACA,SAAA;AAEJ;AADI;EAHF;IAII,sBAAA;EAIJ;AACF;AAHI;EACE,SAAA;AAKN;AAFE;EACE,mBAAA;AAIJ;AAHI;EACE,kBAAA;AAKN;AAFE;EACE,aAAA;EACA,QAAA;EACA,kBAAA;AAIJ;AAFE;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAIJ;AAFE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AAIJ;AAHI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAKN;AAJM;EACE,eAAA;AAMR;AAHI;EACE,SAAA;AAKN;AAFE;EACE,iBAAA;AAIJ;;AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;AAGF;AAFE;EACE,kCAAA;AAIJ;AAFE;EACE,gBAAA;EACA,eAAA;AAIJ;;AAAA;EACE;IACE,uBAAA;EAGF;EADA;IACE,yBAAA;EAGF;AACF;AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;AAEF;AADE;EACE,gBAAA;EACA,eAAA;AAGJ;;AACA;EACE,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAEF;;AACA;EACE,gBAAA;EACA,UAAA;EACA,SAAA;AAEF;AADE;EACE,aAAA;EACA,gDAAA;EACA,QAAA;AAGJ;AADE;EACE,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAGJ;;AACA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AAEF;;AACA,8BAAA;AACA;EACE,qBAAA;EACA,aAAA;EACA,0CAAA;EACA,kBAAA;EACA,gDAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;AAEF;;AACA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AAEF;AADE;EAJF;IAKI,0BAAA;EAIF;AACF;;AADA;EACE,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;AAIF;AAFE;EACE,sBAAA;EACA,eAAA;EACA,0BAAA;AAIJ;AADE;EACE,iBAAA;EACA,qBAAA;EACA,mBAAA;EACA,qBAAA;AAGJ;AAAE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;AAEJ;AADI;EACE,SAAA;EACA,iBAAA;AAGN;AAAI;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;AAEN;AAEE;EACE,6BAAA;EACA,oBAAA;AAAJ;;AAIA;EACE,sBAAA;EACA,eAAA;AADF;AAGE;EACE,cAAA;EACA,kBAAA;AADJ;;AAKA,2CAAA;AACA;EACE,qBAAA;EACA,0CAAA;EACA,kBAAA;EACA,gDAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;AAFF;;AAKA;EACE,aAAA;EACA,eAAA;EACA,SAAA;AAFF;;AAKA;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAFF;AAIE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;AAFJ;AAKE;EACE,gBAAA;EACA,eAAA;AAHJ;AAME;EACE,eAAA;EACA,cAAA;AAJJ;AAOE;EACE,eAAA;EACA,cAAA;AALJ;;AASA;EACE,kBAAA;EACA,kBAAA;AANF;AAQE;EACE,qBAAA;EACA,gBAAA;AANJ;AASE;EACE,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAPJ;;AAUA,sCAAA;AACA;EACE,oBAAA;AAPF;;AAUA;EACE,sBAAA;AAPF;;AAUA;EACE,eAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;AAPF;AASE;EACE,aAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;AAPJ;AASI;EACE,cAAA;AAPN;AASI;EACE,cAAA;AAPN;AASI;EACE,cAAA;AAPN;AASI;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AAPN;AAWE;EACE,kBAAA;EACA,cAAA;AATJ;AAWI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AATN;AAWM;EACE,cAAA;AATR;AAaI;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AAXN;AAaI;EACE,SAAA;EACA,qBAAA;AAXN;AAaI;EACE,kBAAA;AAXN;AAaI;EACE,cAAA;EACA,eAAA;AAXN;;AAgBA;EACE,cAAA;AAbF;;AAgBA,8BAAA;AACA;EACE,qBAAA;EACA,0CAAA;EACA,mBAAA;EACA,gBAAA;EACA,gDAAA;EACA,yCAAA;AAbF;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;EACA,6DAAA;EACA,iDAAA;AAbF;AAeE;EACE,gBAAA;EACA,kBAAA;AAbJ;AAeE;EACE,kBAAA;EACA,mCAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAbJ;AAeE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAbJ;AAeE;EACE,mBAAA;EACA,cAAA;AAbJ;AAeE;EACE,mBAAA;EACA,cAAA;AAbJ;AAeE;EACE,mBAAA;EACA,cAAA;AAbJ;AAeE;EACE,mBAAA;EACA,cAAA;AAbJ;AAeE;EACE,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAbJ;;AAiBA;EACE,aAAA;AAdF;;AAiBA;EACE,aAAA;EACA,oBAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;AAdF;;AAiBA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,8CACE;AAfJ;AAkBE;EACE,qBAAA;EACA,+CAAA;AAhBJ;;AAoBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,6DAAA;EACA,gCAAA;AAjBF;;AAoBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6DAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAjBF;;AAoBA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAjBF;;AAoBA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mCAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAjBF;;AAoBA;EACE,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AAjBF;AAmBE;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAjBJ;;AAqBA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAlBF;;AAqBA;EACE,gBAAA;EACA,8BAAA;AAlBF;;AAqBA;EACE,kBAAA;AAlBF;AAoBE;EACE,gBAAA;AAlBJ;;AAsBA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;AAnBF;;AAsBA;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAnBF;;AAsBA;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;AAnBF;;AAsBA;EACE,SAAA;EACA,gBAAA;AAnBF;;AAsBA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;AAnBF;;AAsBA;EACE,iBAAA;EACA,6BAAA;AAnBF;;AAsBA;EACE;IACE,sBAAA;IACA,oBAAA;EAnBF;EAsBA;IACE,eAAA;IACA,eAAA;EApBF;EAuBA;IACE,yBAAA;IACA,cAAA;EArBF;AACF;AAwBA,yDAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,4BAAA;EACA,gBAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AAtBF;;AAyBA;EACE,mBAAA;AAtBF;;AAwBA;EACE,2BAAA;AArBF;;AAwBA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,UAAA;AArBF;;AAwBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,gDAAA;EACA,oBAAA;AArBF;;AAwBA;EACE,WAAA;EACA,YAAA;AArBF;;AAwBA;EACE,kBAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;EACA,mCAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AArBF;;AAwBA,oCAAA;AACA;EACE,SAAA;EACA,SAAA;EACA,6BAAA,EAAA,eAAA;EACA,eAAA;EACA,kBAAA,EAAA,iCAAA;AArBF;;AAwBA,mDAAA;AACA;EACE,yBAAA;AArBF;;AAuBA;EACE,aAAA;AApBF;;AAuBA,6BAAA;AACA;EACE,WAAA;EACA,kBAAA;EACA,SAAA,EAAA,0CAAA;EACA,SAAA;EACA,2BAAA;EACA,iCAAA;EACA,oCAAA;EACA,8BAAA;AApBF;;AAuBA,4BAAA;AACA;EACE,WAAA;EACA,kBAAA;EACA,SAAA,EAAA,0CAAA;EACA,SAAA;EACA,2BAAA;EACA,iCAAA;EACA,oCAAA;EACA,+BAAA;AApBF;;AAuBA,uCAAA;AACA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,8BAAA,EAAA,eAAA;EACA,WAAA;EACA,2BAAA;AApBF;;AAuBA,iCAAA;AACA;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA,EAAA,4CAAA;EACA,2BAAA;EACA,kCAAA;EACA,mCAAA;EACA,6BAAA;AApBF;;AAuBA;EACE,qBAAA;EACA,6CAAA;AApBF;AAsBE;EACE,qBAAA;EACA,8CAAA;AApBJ;;AAwBA;EACE,6DAAA;EACA,4BAAA;AArBF;;AAwBA;EACE,6DAAA;EACA,eAAA;AArBF;;AAwBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AArBF;;AAwBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;AArBF;;AAwBA;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AArBF","sourcesContent":[".production-lines-split {\n  display: flex;\n  gap: 16px;\n  min-height: 500px;\n  .production-lines-list-panel {\n    flex: 1;\n    min-width: 0;\n  }\n  .production-lines-form-panel {\n    flex: 1;\n    min-width: 320px;\n    max-width: 480px;\n  }\n}\n\n.production-line-form {\n  padding: 16px;\n  .form-row {\n    display: flex;\n    gap: 16px;\n    @media (max-width: 767.98px) {\n      flex-direction: column;\n    }\n    .form-group {\n      flex: 1;\n    }\n  }\n  .form-group {\n    margin-bottom: 1rem;\n    .small {\n      font-size: 0.85rem;\n    }\n  }\n  .form-actions {\n    display: flex;\n    gap: 8px;\n    margin-top: 1.5rem;\n  }\n  .machine-item-block {\n    border: 1px solid #e0e0e0;\n    border-radius: 6px;\n    padding: 10px;\n    margin-bottom: 10px;\n  }\n  .machine-item-header {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 8px;\n    .order-btns {\n      display: flex;\n      align-items: center;\n      gap: 2px;\n      .order-num {\n        min-width: 20px;\n      }\n    }\n    .dropdown-trigger {\n      flex: 1;\n    }\n  }\n  .machine-inventory {\n    margin-left: 28px;\n  }\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  color: #666;\n  .spin {\n    animation: spin 1s linear infinite;\n  }\n  p {\n    margin-top: 16px;\n    font-size: 16px;\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  color: #999;\n  p {\n    margin-top: 16px;\n    font-size: 16px;\n  }\n}\n\n.dropdown-trigger {\n  padding: 10px 12px;\n  border: 1px solid #d0d5dd;\n  border-radius: 4px;\n  cursor: pointer;\n  background: #fff;\n  min-height: 42px;\n}\n\n.line-items-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  &.grid-3 {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 8px;\n  }\n  li {\n    padding: 8px 12px;\n    background: #f8f9fa;\n    border-radius: 4px;\n    margin-bottom: 6px;\n  }\n}\n\n.production-line-form .form-control {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n}\n\n/* --- ANALYTICS SECTION --- */\n.pl-analytics {\n  margin-bottom: 1.5rem;\n  padding: 1rem;\n  border: 1px solid var(--m-border, #e0e0e0);\n  border-radius: 6px;\n  background: var(--m-card-background-color, #fff);\n}\n\n.pl-analytics-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 1rem;\n  font-size: 15px;\n}\n\n.pl-analytics-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n  @media (max-width: 900px) {\n    grid-template-columns: 1fr;\n  }\n}\n\n.pl-analytics-card {\n  padding: 0.75rem;\n  border: 1px solid #eee;\n  border-radius: 6px;\n  background: #fafafa;\n\n  h6 {\n    margin-bottom: 0.75rem;\n    font-size: 13px;\n    color: var(--m-text, #333);\n  }\n\n  &.pl-analytics-card--full {\n    grid-column: 1 / -1;\n    padding: 1rem 1.25rem;\n    background: #f9fafb;\n    border-color: #e5e7eb;\n  }\n\n  .pl-analytics-card__header {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    h6 {\n      margin: 0;\n      font-size: 0.9rem;\n    }\n\n    .pl-model-select-wrap {\n      min-width: 220px;\n      max-width: 320px;\n      margin-bottom: 0;\n    }\n  }\n\n  .pl-analytics-card__body {\n    border-top: 1px solid #e5e7eb;\n    padding-top: 0.75rem;\n  }\n}\n\n.pl-usage-line {\n  margin-bottom: 0.75rem;\n  font-size: 12px;\n\n  strong {\n    display: block;\n    margin-bottom: 4px;\n  }\n}\n\n/* --- INVENTORY SECTION (line items) --- */\n.pl-inventory-section {\n  padding: 1rem 1.25rem;\n  border: 1px solid var(--m-border, #e0e0e0);\n  border-radius: 6px;\n  background: var(--m-card-background-color, #fff);\n}\n\n.pl-section-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 1rem;\n  font-size: 15px;\n}\n\n.pl-inventory-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.pl-inventory-card {\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  background: #f9fafb;\n  padding: 10px 14px;\n  min-width: 200px;\n\n  .pl-inventory-card__body {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 8px 12px;\n  }\n\n  .pl-inventory-name {\n    font-weight: 600;\n    font-size: 14px;\n  }\n\n  .pl-inventory-code {\n    font-size: 12px;\n    color: #6b7280;\n  }\n\n  .pl-inventory-qty {\n    font-size: 12px;\n    color: #374151;\n  }\n}\n\n.pl-usage-machine {\n  padding-left: 1rem;\n  margin-bottom: 4px;\n\n  .pl-usage-machine-name {\n    display: inline-block;\n    min-width: 120px;\n  }\n\n  .pl-usage-item {\n    display: inline-block;\n    margin-right: 8px;\n    padding: 2px 6px;\n    background: #e8f4fd;\n    border-radius: 4px;\n  }\n}\n/* when showing only totals per line */\n.pl-usage-total-list {\n  padding-left: 0.5rem;\n}\n\n.pl-model-select-wrap {\n  margin-bottom: 0.75rem;\n}\n\n.pl-model-detail {\n  font-size: 12px;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n\n  .pl-model-stats {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px 16px;\n    margin-bottom: 0.75rem;\n\n    .pl-model-produced {\n      color: #0ea5e9;\n    }\n    .pl-model-max {\n      color: #22c55e;\n    }\n    .pl-model-shortage {\n      color: #ef4444;\n    }\n    .pl-model-bottleneck {\n      display: inline-flex;\n      align-items: center;\n      gap: 4px;\n      color: #f59e0b;\n    }\n  }\n\n  .pl-model-usage {\n    margin-top: 0.5rem;\n    display: block;\n\n    .pl-model-usage-toggle {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      width: 100%;\n      padding: 6px 0;\n      margin-bottom: 4px;\n      border: 0;\n      background: transparent;\n      font-size: 12px;\n      font-weight: 600;\n      color: #334155;\n      cursor: pointer;\n      text-align: left;\n\n      &:hover {\n        color: #0f766e;\n      }\n    }\n\n    .pl-model-usage-toggle-icon {\n      font-weight: 700;\n      font-size: 14px;\n      color: #0f766e;\n      padding-left: 8px;\n    }\n    ul {\n      margin: 0;\n      padding-left: 1.25rem;\n    }\n    li {\n      margin-bottom: 4px;\n    }\n    .pl-model-usage-stock {\n      color: #94a3b8;\n      font-size: 11px;\n    }\n  }\n}\n\n.text-muted {\n  color: #94a3b8;\n}\n\n/* --- STEP-BASED LAYOUT --- */\n.pl-lane--steps {\n  margin-bottom: 1.5rem;\n  border: 1px solid var(--m-border, #e2e8f0);\n  border-radius: 10px;\n  overflow: hidden;\n  background: var(--m-card-background-color, #fff);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n}\n\n.pl-lane-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding: 14px 20px;\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  border-bottom: 1px solid var(--m-border, #e2e8f0);\n\n  .pl-name {\n    font-weight: 600;\n    font-size: 1.05rem;\n  }\n  .pl-code {\n    font-size: 0.85rem;\n    color: var(--m-text-muted, #64748b);\n    padding: 2px 8px;\n    background: #e2e8f0;\n    border-radius: 4px;\n  }\n  .pl-badge {\n    font-size: 11px;\n    padding: 3px 8px;\n    border-radius: 4px;\n    font-weight: 500;\n  }\n  .pl-type-production {\n    background: #dbeafe;\n    color: #1d4ed8;\n  }\n  .pl-type-selling {\n    background: #dcfce7;\n    color: #15803d;\n  }\n  .pl-entry-manual {\n    background: #fef3c7;\n    color: #b45309;\n  }\n  .pl-entry-from_machine {\n    background: #e0e7ff;\n    color: #4338ca;\n  }\n  .pl-total-badge {\n    margin-left: auto;\n    font-size: 0.9rem;\n    font-weight: 600;\n    color: #0ea5e9;\n    background: #e0f2fe;\n    padding: 4px 12px;\n    border-radius: 6px;\n  }\n}\n\n.pl-steps {\n  padding: 20px;\n}\n\n.pl-steps-pipeline {\n  display: flex;\n  align-items: stretch;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.pl-step-card {\n  display: flex;\n  flex-direction: column;\n  flex: 0 0 220px;\n  width: 220px;\n  min-height: 140px;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n  transition:\n    box-shadow 0.2s,\n    border-color 0.2s;\n\n  &:hover {\n    border-color: #cbd5e1;\n    box-shadow: 0 4px 12px rgba(14, 165, 233, 0.08);\n  }\n}\n\n.pl-step-card-head {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 14px;\n  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.pl-step-num {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  border-radius: 6px;\n  background: linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%);\n  color: #fff;\n  font-weight: 700;\n  font-size: 12px;\n  flex-shrink: 0;\n}\n\n.pl-step-machine {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--m-text, #334155);\n  line-height: 1.3;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.pl-step-card-body {\n  padding: 12px 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.pl-step-label {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--m-text-muted, #64748b);\n}\n\n.pl-step-input-wrap {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.pl-produced-input {\n  width: 72px;\n  padding: 8px 10px;\n  border: 1px solid #cbd5e1;\n  border-radius: 6px;\n  font-size: 15px;\n  font-weight: 600;\n  color: #0ea5e9;\n  text-align: right;\n  background: #fff;\n\n  &:focus {\n    outline: none;\n    border-color: #0ea5e9;\n    box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.2);\n  }\n}\n\n.pl-step-unit {\n  font-size: 12px;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.pl-step-continuity {\n  padding-top: 8px;\n  border-top: 1px dashed #e2e8f0;\n}\n\n.pl-step-row {\n  margin-bottom: 6px;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.pl-step-sublabel {\n  display: block;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  color: #94a3b8;\n  margin-bottom: 4px;\n}\n\n.pl-step-continuity-value {\n  display: block;\n  font-size: 12px;\n  color: #334155;\n  font-weight: 600;\n}\n\n.pl-step-continuity-warn {\n  display: block;\n  font-size: 11px;\n  color: #b45309;\n  background: #fffbeb;\n  border: 1px solid #fde68a;\n  padding: 4px 6px;\n  border-radius: 6px;\n}\n\n.machine-item-continuity .form-row--sm .form-group {\n  flex: 1;\n  margin-bottom: 0;\n}\n\n.pl-step-connector {\n  display: flex;\n  align-items: center;\n  padding: 0 6px;\n  color: #94a3b8;\n  font-size: 18px;\n  align-self: center;\n  flex-shrink: 0;\n}\n\n.pl-step-actions {\n  padding-top: 16px;\n  border-top: 1px solid #e2e8f0;\n}\n\n@media (max-width: 600px) {\n  .pl-steps-pipeline {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .pl-step-card {\n    min-width: 100%;\n    max-width: none;\n  }\n\n  .pl-step-connector {\n    transform: rotate(-90deg);\n    padding: 4px 0;\n  }\n}\n\n/* --- SNAKE LAYOUT STYLES (legacy, kept if needed) --- */\n.snake-container {\n  display: flex;\n  flex-direction: column;\n  gap: 60px;\n  padding: 20px 10px 40px 10px;\n  overflow-x: auto;\n}\n\n.snake-row {\n  display: flex;\n  align-items: center;\n  min-width: 500px;\n}\n\n.snake-row.ltr {\n  flex-direction: row;\n}\n.snake-row.rtl {\n  flex-direction: row-reverse;\n}\n\n.snake-node-wrapper {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 60px;\n  z-index: 2;\n}\n\n.pl-machine-circle {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: 2px solid #000080;\n  background: var(--m-card-background-color, #fff);\n  transition: all 0.2s;\n}\n\n.pl-circle-large {\n  width: 48px;\n  height: 48px;\n}\n\n.pl-machine-label {\n  position: absolute;\n  top: 100%;\n  margin-top: 8px;\n  font-size: 11px;\n  color: var(--m-text-muted, #64748b);\n  text-align: center;\n  width: 100px;\n  line-height: 1.2;\n  font-weight: 500;\n}\n\n/* Base style for horizontal lines */\n.snake-line-h {\n  flex: 1;\n  height: 0;\n  border-top: 2px solid #000080; /* Solid line */\n  min-width: 30px;\n  position: relative; /* Needed for arrow positioning */\n}\n\n/* Hide lines (and their arrows) when appropriate */\n.snake-line-h.hidden-line {\n  border-color: transparent;\n}\n.snake-line-h.hidden-line::after {\n  display: none;\n}\n\n/* LTR Right-pointing arrow */\n.snake-row.ltr .snake-line-h::after {\n  content: \"\";\n  position: absolute;\n  top: -4px; /* Centered vertically over the 2px line */\n  left: 50%;\n  transform: translateX(-50%);\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  border-left: 8px solid #000080;\n}\n\n/* RTL Left-pointing arrow */\n.snake-row.rtl .snake-line-h::after {\n  content: \"\";\n  position: absolute;\n  top: -4px; /* Centered vertically over the 2px line */\n  left: 50%;\n  transform: translateX(-50%);\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  border-right: 8px solid #000080;\n}\n\n/* Base style for vertical drop lines */\n.snake-line-v {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  height: 108px;\n  border-left: 2px solid #000080; /* Solid line */\n  z-index: -1;\n  transform: translateX(-50%);\n}\n\n/* Vertical Down-pointing arrow */\n.snake-line-v::after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: -4px; /* Centered horizontally over the 2px line */\n  transform: translateY(-50%);\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-top: 8px solid #000080;\n}\n\n.pl-step-card--final {\n  border-color: #22c55e;\n  box-shadow: 0 0 0 2px rgba(34, 197, 94, 0.15);\n\n  &:hover {\n    border-color: #16a34a;\n    box-shadow: 0 4px 12px rgba(34, 197, 94, 0.18);\n  }\n}\n\n.pl-step-card-head--final {\n  background: linear-gradient(180deg, #f0fdf4 0%, #dcfce7 100%);\n  border-bottom-color: #bbf7d0;\n}\n\n.pl-step-num--final {\n  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);\n  font-size: 14px;\n}\n\n.pl-final-name {\n  font-size: 14px;\n  font-weight: 700;\n  color: #15803d;\n  line-height: 1.3;\n}\n\n.pl-final-code {\n  font-size: 11px;\n  font-weight: 600;\n  color: #64748b;\n  letter-spacing: 0.04em;\n}\n\n.pl-final-stock {\n  display: inline-block;\n  margin-top: 4px;\n  padding: 3px 8px;\n  border-radius: 20px;\n  background: #dcfce7;\n  color: #15803d;\n  font-size: 12px;\n  font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
